import { Chip, Popper } from '@mui/material';
import { RadioFilter, SelectFilter, TextFieldsFilter, MultiOptionFilter } from './staticFiltersComponents';
import { useMemo, useState } from 'react';

import { AppUseIcon } from 'components/ui';
import DateRangeSeparatePickersFilter from './staticFiltersComponents/DateRangeSeparatePickersFilter';
import { IAppTableFilters } from 'services/AppTableFilters';
import { useTranslation } from 'react-i18next';

export const GetColumnFilterComponent = (filter: any, CallBackFn = (value: any) => {}) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const applyFilter = (value?: any) => {
    setAnchorElement(null);
    filter.onApply(value);
    CallBackFn(value);
  };

  const getComponentByFilterType = useMemo(() => {
    return {
      textfields: () => <TextFieldsFilter filter={filter} onApply={applyFilter} />,
      select: () => <SelectFilter filter={filter} onApply={applyFilter} />,
      'date-range-separate-pickers': () => <DateRangeSeparatePickersFilter filter={filter} onApply={applyFilter} />,
      radio: () => <RadioFilter filter={filter} onApply={applyFilter} />,
      multioption: () => <MultiOptionFilter filter={filter} onApply={applyFilter} />
    }[filter.type]?.();
  }, [filter.type, filter.options]);

  return (
    <div className={`filter-button-and-popup `}>
      <button
        type='button'
        className='popup-activate-button mx-1 btn btn-transparent p-0'
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorElement(anchorElement ? null : event.currentTarget);
        }}
      >
        <AppUseIcon name='FilterIcon' height='17' width='16' color='currentColor' />
      </button>
      {!!anchorElement && (
        <>
          <div className='backdrop' onClick={() => setAnchorElement(null)} />

          <Popper
            data-test={'filter-popper'}
            className={`${filter.className || ''}`}
            open={!!anchorElement}
            anchorEl={anchorElement}
            placement='bottom'
          >
            <div>{getComponentByFilterType}</div>
          </Popper>
        </>
      )}
    </div>
  );
};

export const getFilterChips = (appTableFiltersInstance: IAppTableFilters) => {
  return FilterChips(appTableFiltersInstance.filters.map((f) => ({ ...f, onRemove: appTableFiltersInstance.removeFilter })));
};

export const FilterChips = (filters: any[]) => {
  const { t } = useTranslation();
  return (
    <div data-test='current-filters' className='current-filters'>
      {filters.length === 0 && <span className='no-filters font-400 font-15 font-lato px-2'>{t('added_filters_will_appear_here')}</span>}
      {filters?.map((f, index) => FChip(f, index))}
    </div>
  );
};

const FChip = (filter: any, index: number) => {
  return (
    <div key={index} className='current-filter overflow-ellipsis' title={filter.label}>
      <Chip id={`filter-chip-${filter?.id}-${index}`} key={index} label={filter.label} onDelete={() => filter.onRemove(filter)} />
    </div>
  );
};
